import { milliseconds } from "./key-milliseconds";
export function date(key) {
    return new Date(milliseconds(key));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-key/dist/key-date.js
// module id = 2184
// module chunks = 0